import { render } from "./App.vue?vue&type=template&id=ab2d12d8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ab2d12d8&lang=scss"
script.render = render

export default script